var _linearGradient, _path, _linearGradient2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngularOriginal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 14.704,
    x2: 110.985,
    y1: 46.27,
    y2: 92.024,
    gradientTransform: "matrix(1 0 0 -1 0 130)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e40035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#f60a48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#f20755"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#dc087d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.745,
    stopColor: "#9717e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6c00f5"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m124.5 21.3-4.4 68.6L78.3 0l46.2 21.3zm-29 88.7L64 128l-31.5-18 6.4-15.5h50.3l6.3 15.5zM64 34.1l16.5 40.2h-33L64 34.1zM7.9 89.9 3.5 21.3 49.7 0 7.9 89.9z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 28.733,
    x2: 91.742,
    y1: 117.071,
    y2: 45.195,
    gradientTransform: "matrix(1 0 0 -1 0 130)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff31d9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff5be1",
    stopOpacity: 0
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "m124.5 21.3-4.4 68.6L78.3 0l46.2 21.3zm-29 88.7L64 128l-31.5-18 6.4-15.5h50.3l6.3 15.5zM64 34.1l16.5 40.2h-33L64 34.1zM7.9 89.9 3.5 21.3 49.7 0 7.9 89.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngularOriginal);
export default __webpack_public_path__ + "static/media/angular-original.ba160e003b9f917f9df1fabc10a07c14.svg";
export { ForwardRef as ReactComponent };